import {
  BreakpointsEnum,
  InformationPanel,
  isBreakpointUp,
  useBreakpoint,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {useSelector} from 'Provider';
import CAESARS_LAUREL_GRAY from 'assets/OfferCardIcons/caesars_laurel_gray.svg';
import {useFontFamily} from 'hooks/useFontFamily';
import {Box, Text} from 'native-base';
import React from 'react';

import {isDomMarketBannerVisibleSelector} from 'store/offers/offers.selectors';

export interface OffersEmptyDisplayProps {
  isFavoriteTab: boolean;
  isInitialDomMarket: boolean;
  onClearPress?: () => void;
  domMarketName?: string | undefined;
}

const OffersEmptyDisplay: React.FC<OffersEmptyDisplayProps> = ({
  isFavoriteTab,
  isInitialDomMarket = false,
  onClearPress,
  domMarketName = '',
}) => {
  const isDesktop = useIsDesktop();
  const isDomMarketBannerVisible = useSelector(
    isDomMarketBannerVisibleSelector
  );

  const bodyFontFamily = useFontFamily('body', 400);
  const boldBodyFontFamily = useFontFamily('body', 700);

  return (
    <InformationPanel
      hasShadow={true}
      isSVG={true}
      iconName={CAESARS_LAUREL_GRAY}
      iconSize={{height: 79, width: 91}}
      iconIsLight={true}
      titleText={
        isFavoriteTab ? 'You have no favorites... Yet!' : 'Want more offers?'
      }
      upperDescriptionText={
        !isFavoriteTab && isInitialDomMarket
          ? ''
          : isFavoriteTab
            ? "You don't have any offers that have been favorited."
            : 'Visit the casino floor, book a room, or enjoy dining, shows, and more.'
      }
      lowerDescriptionText={
        isFavoriteTab
          ? 'Explore offers to find exciting ways to play, dine, win and more.'
          : isInitialDomMarket
            ? ''
            : 'Or try adjusting your filters.'
      }
      ctaText={
        !isFavoriteTab && isDomMarketBannerVisible
          ? 'clear location'
          : !isFavoriteTab && !isDomMarketBannerVisible
            ? 'clear filters'
            : undefined
      }
      onCTAPress={onClearPress}>
      {!isFavoriteTab && isInitialDomMarket ? (
        <Box
          w="100%"
          display="flex"
          flexDirection="column"
          justifyContent="center">
          <Text
            textAlign="center"
            fontFamily={bodyFontFamily}
            fontSize={isDesktop ? '18px' : '14px'}
            lineHeight={isDesktop ? '30px' : '24px'}>
            There are no available offers for
            <Text
              bold
              textAlign="center"
              fontFamily={boldBodyFontFamily}
              fontSize={isDesktop ? '18px' : '14px'}
              lineHeight={isDesktop ? '30px' : '24px'}>
              {' '}
              {domMarketName}.
            </Text>
            {'\n'} Try adjusting your filters to view offers across The Empire.
          </Text>
        </Box>
      ) : undefined}
    </InformationPanel>
  );
};

export default OffersEmptyDisplay;
